import { TValidator } from "../../../wizard/types";

const branchFormValidator: TValidator = async ({ values }) => {
  const errors: { [key: string]: any } = {};

  if (values.hasOwnProperty("country")) {
    if (!values.country) {
      errors.country = "Country is required";
    }
  }

  if (values.state) {
    if (values.state.trim().length < 2) {
      errors.state = "State must have minimum 2 characters";
    }

    if (values.state.trim().length > 20) {
      errors.state = "State must have maximum 20 characters";
    }
  }

  if (!values.city) {
    errors.city = "City is required";
  } else {
    if (values.city.trim().length < 2) {
      errors.city = "City must have minimum 2 characters";
    }

    if (values.city.trim().length > 20) {
      errors.city = "City must have maximum 20 characters";
    }
  }

  if (!values.address) {
    errors.address = "Address is required";
  } else {
    if (values.address.trim().length < 2) {
      errors.address = "Address must have minimum 2 characters";
    }

    if (values.address.trim().length > 150) {
      errors.address = "Address must have maximum 150 characters";
    }
  }

  if (!values.zip) {
    errors.zip = "Zip is required";
  } else {
    if (values.zip.trim().length < 4) {
      errors.zip = "Zip must have minimum 4 characters";
    }

    if (values.zip.trim().length > 15) {
      errors.zip = "Zip must have maximum 15 characters";
    }
  }

  if (Object.keys(errors).length > 0) {
    throw errors;
  }
};

export default branchFormValidator;
